import PropTypes from 'prop-types'
import AivySystemMessageIcon from '../icons/AivySystemMessageIcon'

export default function EmptyState({ title, description }) {
  return (
    <div className='flex flex-1 flex-col items-center justify-center px-6 text-center'>
      <div className='mb-4'>
        <AivySystemMessageIcon />
      </div>
      <h3 className='mb-2 text-lg font-semibold text-gray-900'>{title}</h3>
      <p className='text-sm leading-relaxed text-gray-600'>{description}</p>
    </div>
  )
}

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}
